/* eslint-disable @next/next/no-img-element */
import MetaHeader from '@buddieshr/components/metaHeader';
import ProductSchema from '@buddieshr/components/productSchema';
import { useRouter } from 'next/router';
import Header from '@buddieshr/components/header';
import Footer from '@buddieshr/components/footer';
import { PRODUCTS } from '@buddieshr/utils/constants-products';
import {
  PalmyHero,
  PalmyProductDemo,
  PalmyFeatureGrid,
  PalmyReviews,
  PalmyShine,
  PalmyFaq,
  PalmyFinalCTA,
  PalmyCrossSell,
} from '@buddieshr/components/palmy/pageSections';

export default function Home() {
  const router = useRouter();
  const app = PRODUCTS.find((c) => c.id === 'Palmy');

  return (
    <>
      <MetaHeader
        title={'Vacation Tracking App | #1 Slack App - Palmy'}
        description={
          "Handle vacation requests in Slack. Automate approvals and track your team's vacation balance."
        }
        currentURL={`https://buddieshr.com/${
          router.locale === 'en' ? '' : router.locale
        }/vacation-tracker`}
        currentShare={`https://buddieshr.com/img/apps/${app.slug}/share_preview_palmy.png`}
        locale={router.locale}
        pageSlug={app.urlSlug || app.slug}
      />
      <ProductSchema app={app} />
      <Header app={app} />
      <main className="bh">
        <PalmyHero />
        <PalmyProductDemo />
        <PalmyFeatureGrid />
        <PalmyReviews />
        <PalmyShine />
        <PalmyFaq />
        <PalmyFinalCTA app={app} />
        <PalmyCrossSell />
      </main>
      <Footer app={app} />
    </>
  );
}
